import { NxRadioGroupOption } from './types'
import { Label, Description, Group, Container } from './styles/NxRadioGroup.styles'
import { ClbRadioButton, ClbIcon } from '@celebration/react'
import { HelperText } from '../../utils/styles/designSystem'

type NxRadioGroupProps = {
  label?: string
  description?: string
  options: NxRadioGroupOption[]
  value: string | undefined
  onChange: (value: string) => void
  showHelperText?: boolean
  helperText?: string
  showError?: boolean
  error?: string
  disabled?: boolean
  stopPropagation?: boolean
}

const NxRadioGroup = ({
  label,
  description,
  options,
  value,
  onChange,
  showHelperText = false,
  helperText,
  showError = false,
  error,
  disabled = false,
  stopPropagation = false,
}: NxRadioGroupProps): React.ReactElement => {

  const handlePropagation = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation()
      return
    }
    return undefined
  }
  return (
    <Container data-testid='radio-group'>
      {label && <Label>{label}</Label>}
      {description && <Description>{description}</Description>}
      <Group onClick={handlePropagation}>
        {options.map((opt) => (
          <ClbRadioButton
            key={opt.id}
            id={opt.id}
            label={opt.label}
            onChange={() => onChange(opt.value)}
            checked={value === opt.value}
            disabled={disabled}
          />
        ))}
      </Group>
      {(showHelperText || showError) && (
        <HelperText $hasError={showError} style={{ margin: '6px 0' }}>
          <ClbIcon size='sm' icon='spam' type='negative' />
          {error ?? helperText}
        </HelperText>
      )}
    </Container>
  )
}

export default NxRadioGroup
